import React from "react";
import { Container } from "@mui/material";
import { HeroGeometric } from "./shape-landing-hero";
import { FeatureSteps } from "./FeatureSteps";
import TestimonialCarousel from "./Testimonals";
import AboutUs from "./AboutUs";
import Pricing from "./Pricing";
import Cta from "./Cta";
import { PricingFlag } from "../../config";
const LandingPage = () => {

  return (
    <>
      <section id="hero">
        <HeroGeometric
          badge="HireBest AI"
          title2="Revolutionizing &amp; Automating Interviews"
        />
      </section>
      <Container maxWidth="lg">
        <section id="features">
          <FeatureSteps
            title="Features"
            autoPlayInterval={3000}
          />
        </section>
        <section id="testimonials">
          <TestimonialCarousel />
        </section>
        {PricingFlag && (
          <section id="pricing">
            <Pricing />
          </section>
        )}
        <section id="about">
          <AboutUs />
        </section>
        <section id="contact">
          <Cta />
        </section>
      </Container>
    </>
  );
};

export default LandingPage;